import { IVector2 } from '@easytwin/runtime';
import * as React from 'react';
import { ProInputPercentNumber } from '../ProInputPercentNumber';
import { GridMatrix } from './GridMatrix';

interface GridMatrixWithInputProps {
  pos: IVector2 | undefined;
  onChange: (value: IVector2) => void;
  onConfirm: (value: IVector2) => void;
}

export function GridMatrixWithInput(props: GridMatrixWithInputProps) {
  const { pos = { x: 0, y: 0 }, onChange, onConfirm } = props;

  return (
    <div className='w-full flex gap-x-2 py-1'>
      <GridMatrix pos={pos} onPosChanged={onConfirm} />
      <div className='flex flex-col gap-y-2 flex-1'>
        <ProInputPercentNumber
          prefix='X'
          suffix='%'
          name='x'
          value={pos.x}
          onChange={(name: string, value) => {
            onChange({
              x: value,
              y: pos.y,
            });
          }}
          onBlur={(name, value) => {
            onConfirm({
              x: value,
              y: pos.y,
            });
          }}
          onPointMoveStart={(name: string, value) => {
            value !== undefined &&
              onChange({
                x: value,
                y: pos.y,
              });
          }}
          onPointMoveEnd={(name, value) => {
            onConfirm({
              x: value,
              y: pos.y,
            });
          }}
        />
        <ProInputPercentNumber
          prefix='Y'
          name='y'
          suffix='%'
          value={pos.y}
          onChange={(name: string, value) => {
            onChange({
              x: pos.x,
              y: value,
            });
          }}
          onBlur={(name, value) => {
            onConfirm({
              x: pos.x,
              y: value,
            });
          }}
          onPointMoveStart={(name: string, value) => {
            value !== undefined &&
              onChange({
                x: pos.x,
                y: value,
              });
          }}
          onPointMoveEnd={(name, value) => {
            onConfirm({
              x: pos.x,
              y: value,
            });
          }}
        />
      </div>
    </div>
  );
}
